/**
 * Photo & Craft — Custom Product Variant Selector v2.1
 * List-style size rows with price, frame swatches, mount toggle
 *
 * v2.1: SIZE_ORDER + DIMENSIONS updated to the six-tier ladder
 *       (added Collector + Exhibition; corrected all dimension strings to
 *       match the pipeline's Option2 output). Old four-size constants were
 *       why the page still showed the old sizes after import.
 */
(function() {
  'use strict';

  var STYLE_ORDER = ['Borders', 'Full Bleed'];
  var SIZE_ORDER = ['Small', 'Medium', 'Large', 'Gallery', 'Collector', 'Exhibition'];
  var FRAME_ORDER = ['Black', 'White', 'Grey', 'Maple', 'Walnut', 'Oak', 'Black Walnut', 'White Maple'];

  // Dimensions shown in each size row (outer framed dims for Borders/Full Bleed;
  // print size for Print Only). These MUST match the pipeline's Option2 strings.
  var DIMENSIONS = {
    'Borders':    { 'Small': '13 × 18', 'Medium': '19 × 26', 'Large': '27 × 38', 'Gallery': '33 × 47', 'Collector': '41 × 59', 'Exhibition': '49 × 71' },
    'Full Bleed': { 'Small': '13 × 19', 'Medium': '17 × 25', 'Large': '25 × 37', 'Gallery': '31 × 46', 'Collector': '41 × 61', 'Exhibition': '49 × 73' },
    'Print Only': { 'Small': '12 × 18', 'Medium': '16 × 24', 'Large': '24 × 36', 'Gallery': '30 × 45', 'Collector': '40 × 60', 'Exhibition': '48 × 72' }
  };

  function getSizePrice(variantMap, state, sizeName) {
    var v;
    if (state.type === 'Print Only') {
      v = variantMap['Print Only|Print Only|' + sizeName + '|None'];
    } else {
      v = variantMap['Framed|' + state.style + '|' + sizeName + '|' + state.frame];
    }
    if (!v) return '';
    return '$' + (v.price / 100).toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
  }

  function init() {
    var productJson = document.querySelector('[data-pc-product-json]');
    if (!productJson) return;
    var product;
    try { product = JSON.parse(productJson.textContent); } catch(e) { return; }

    var variantPicker = document.querySelector('variant-selects, variant-radios');
    var productForm = document.querySelector('.product-form');
    if (!productForm && !variantPicker) return;

    var container = document.createElement('div');
    container.className = 'pc-variant-selector';
    if (variantPicker) {
      variantPicker.parentNode.insertBefore(container, variantPicker);
    } else if (productForm) {
      productForm.insertBefore(container, productForm.firstChild);
    }

    document.querySelectorAll('variant-selects, variant-radios, .product-form__input--pill, .product-form__input--dropdown').forEach(function(el) { el.style.display = 'none'; });
    var dp = document.querySelector('.price');
    if (dp) dp.style.display = 'none';
    document.querySelectorAll('.quantity__input, .product-form__quantity, quantity-input').forEach(function(el) {
      var p = el.closest('.product-form__input') || el.parentElement;
      if (p) p.style.display = 'none';
    });

    var parsed = parseVariants(product.variants);
    var state = { type: 'Framed', style: 'Borders', size: 'Small', frame: 'Black' };
    render(container, parsed, state);
  }

  function parseVariants(variants) {
    var map = {};
    variants.forEach(function(v) {
      var type = v.option1;
      var sizeRaw = v.option2;
      var frame = v.option3;
      var style, sizeName;
      if (type === 'Print Only') {
        style = 'Print Only';
        sizeName = sizeRaw.split('\u2014')[0].trim().split('/').pop().trim();
      } else {
        var parts = sizeRaw.split('/');
        style = parts[0].trim();
        sizeName = parts[1] ? parts[1].split('\u2014')[0].trim() : sizeRaw.split('\u2014')[0].trim();
      }
      map[type + '|' + style + '|' + sizeName + '|' + frame] = v;
    });
    return map;
  }

  function findVariant(map, state) {
    if (state.type === 'Print Only') return map['Print Only|Print Only|' + state.size + '|None'];
    return map['Framed|' + state.style + '|' + state.size + '|' + state.frame];
  }

  function render(container, variantMap, state) {
    function update() {
      var variant = findVariant(variantMap, state);

      // Update ALL id inputs on the page (main form + installment/paypal form + any others).
      // Previously only updated the first match, which caused Dawn's second form to submit
      // the original default variant instead of the user's selection.
      if (variant) {
        document.querySelectorAll('input[name="id"]').forEach(function(idInput) {
          idInput.value = variant.id;
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }

      // Trigger Dawn's media swap manually — our custom UI bypasses variant-selects,
      // so we directly swap to this variant's featured media.
      if (variant && variant.featured_media && variant.featured_media.id) {
        var productInfo = document.querySelector('product-info');
        if (productInfo) {
          var sectionId = productInfo.dataset.section;
          var mediaGallery = productInfo.querySelector('media-gallery');
          if (mediaGallery && mediaGallery.setActiveMedia) {
            mediaGallery.setActiveMedia(sectionId + '-' + variant.featured_media.id, true);
          }
        }
      }

      var addBtn = document.querySelector('.product-form__submit, [name="add"], button[type="submit"]');
      if (addBtn && variant) {
        addBtn.disabled = !variant.available;
        addBtn.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
      }

      // Optium glazing only applies to FRAMED pieces — a bare print has nothing
      // to glaze. Hide the glazing block for Print Only and reset it to standard
      // so no stale Optium upgrade carries over when switching type.
      var glazing = document.querySelector('[data-glazing]');
      if (glazing) {
        if (state.type === 'Print Only') {
          glazing.style.display = 'none';
          var gbox = glazing.querySelector('[data-glazing-toggle]');
          var ghidden = glazing.querySelector('[data-glaze-value]');
          if (gbox && gbox.classList.contains('active')) {
            gbox.classList.remove('active');
            gbox.setAttribute('aria-pressed', 'false');
            if (ghidden) {
              ghidden.value = 'standard';
              ghidden.dispatchEvent(new Event('change', { bubbles: true }));
            }
            glazing.dispatchEvent(new CustomEvent('pc:glaze-change', {
              bubbles: true, detail: { value: 'standard', optiumVariantId: null }
            }));
          }
        } else {
          glazing.style.display = '';
        }
      }

      draw();
    }

    function draw() {
      var isFramed = state.type === 'Framed';
      var dims = isFramed ? DIMENSIONS[state.style] : DIMENSIONS['Print Only'];
      var cv = findVariant(variantMap, state);
      var cp = cv ? '$' + (cv.price / 100).toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 }) : '';

      var html =
        '<div class="pc-sel">' +

        '<div class="pc-price-display">' + cp + '</div>' +

        '<div class="pc-group">' +
          '<div class="pc-toggle pc-type-toggle">' +
            '<button class="' + (isFramed ? 'active' : '') + '" data-type="Framed">Framed</button>' +
            '<button class="' + (!isFramed ? 'active' : '') + '" data-type="Print Only">Print Only</button>' +
          '</div>' +
        '</div>' +

        // Mount (Borders / Full Bleed) — framed only, placed directly under Type.
        (isFramed
          ? '<div class="pc-group">' +
              '<div class="pc-toggle pc-style-toggle">' +
                STYLE_ORDER.map(function(s) {
                  return '<button class="' + (state.style === s ? 'active' : '') + '" data-style="' + s + '">' + s + '</button>';
                }).join('') +
              '</div>' +
            '</div>'
          : '') +

        '<div class="pc-group">' +
          '<span class="pc-label">Size:</span>' +
          '<div class="pc-size-list">';

      SIZE_ORDER.forEach(function(s) {
        var sp = getSizePrice(variantMap, state, s);
        // Skip a size row if no matching variant exists for the current selection
        // (keeps the list clean if a particular size/frame combo wasn't generated).
        var dimText = dims[s] ? dims[s] + ' in' : '';
        html += '<button class="pc-size-row ' + (state.size === s ? 'active' : '') + '" data-size="' + s + '">' +
          '<span class="pc-size-row-name">' + s + '</span>' +
          '<span class="pc-size-row-dims">' + dimText + '</span>' +
          '<span class="pc-size-row-price">' + sp + '</span>' +
        '</button>';
      });

      html += '</div></div>';

      if (isFramed) {
        html += '<div class="pc-group">' +
          '<span class="pc-label">Frame: <span class="pc-frame-selected">' + state.frame + '</span></span>' +
          '<div class="pc-frame-swatches">';

        FRAME_ORDER.forEach(function(f) {
          html += '<button class="pc-frame-swatch ' + (state.frame === f ? 'active' : '') + '" data-frame="' + f + '" title="' + f + '">' +
            '<span class="pc-swatch-color" data-color="' + f.toLowerCase().replace(/\s+/g, '-') + '"></span>' +
          '</button>';
        });

        html += '</div></div>';
      }

      html += '<div class="pc-delivery">Estimated delivered in 16 business days</div>';
      html += '</div>';

      container.innerHTML = html;

      container.querySelectorAll('.pc-type-toggle button').forEach(function(btn) {
        btn.addEventListener('click', function() {
          state.type = btn.dataset.type;
          if (state.type === 'Print Only') { state.frame = 'None'; }
          else { state.frame = 'Black'; state.style = 'Borders'; }
          update();
        });
      });
      container.querySelectorAll('.pc-style-toggle button').forEach(function(btn) {
        btn.addEventListener('click', function() { state.style = btn.dataset.style; update(); });
      });
      container.querySelectorAll('.pc-size-row').forEach(function(btn) {
        btn.addEventListener('click', function() { state.size = btn.dataset.size; update(); });
      });
      container.querySelectorAll('.pc-frame-swatch').forEach(function(btn) {
        btn.addEventListener('click', function() { state.frame = btn.dataset.frame; update(); });
      });
    }
    update();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();